import { LayoutTemplate } from "../LayoutTemplate";

export const LayoutTemplateV2 = () => {
  return <LayoutTemplate />;
};
